import { useSelector } from "react-redux";

import styles from "./AppliedProducts.module.css";
import { generateThumbnail } from "../../Helpers/ThumbHelper";

export default function AppliedProducts() {

    const floorPlanSteps = useSelector((state) => state.visualizer.activeFloorPlanSteps);
    const activePackage = useSelector((state) => state.visualizer.activePackage);

    const exteriorProducts = [];
    const kitchenProducts = [];
    const bathroomProducts = [];

    floorPlanSteps.forEach(step => {
        if(step.selection !== -1){

            const productOne = step.selection;
            const productTwo = step.secondarySelection;


            if (!productOne || productOne.id === -1 || typeof productOne != 'object')
                return;

            // Generate thumbnails
            const thumbOne = generateThumbnail(productOne, 250, 500);
            const thumbTwo = (typeof productTwo === 'object' && productTwo !== null) ? generateThumbnail(productTwo, 250, 500) : null;


            var productItem = (
                <li>
                    <div className={styles.imageWrapper} data-step={step.step}>
                        <img src={thumbOne} alt={`${productOne.name} Thumbnail`} />
                        {thumbTwo && <img src={thumbTwo} alt={`${productTwo.name} Thumbnail`} />}
                    </div>
                    <div className={styles.productNames}>
                        <div className={styles.title}>{productOne.name}</div>
                        <div className={styles.subTitle}>{productOne.color}</div>
                        {productTwo && (
                            <>
                                <div className={styles.title}>{productTwo.name}</div>
                                <div className={styles.subTitle}>{productTwo.color}</div>
                            </>
                        )}
                    </div>
                </li>
            );

            // Push product item to the appropriate area
            if (step.area === "exterior") exteriorProducts.push(productItem);
            if (step.area === "kitchen") kitchenProducts.push(productItem);
            if (step.area === "bathroom") bathroomProducts.push(productItem);

        }
    })


    const extScheme = activePackage !== null ? (
        <div className={styles.extScheme}>
            <div className={styles.title}>{activePackage.scheme}</div>
            <div className={styles.colorsList}>
                <div className={styles.color}>
                    <div className={styles.area}>Body</div>
                    <img loading='lazy' src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=!${activePackage.bodyChamID}&type=prod&extra=(focus=200)&Size=200`} alt={`Product - ${activePackage.bodyChamID}`} />
                    <div className={styles.name}>{activePackage.body}</div>
                </div>
                <div className={styles.color}>
                    <div className={styles.area}>Trim</div>
                    <div className={styles.thumb}><img loading='lazy' src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=!${activePackage.trimChamID}&type=prod&extra=(focus=200)&Size=200`} alt={`Product - ${activePackage.trimChamID}`} /></div>
                    <div className={styles.name}>{activePackage.trim}</div>
                </div>
                <div className={styles.color}>
                    <div className={styles.area}>Front Door</div>
                    <div className={styles.thumb}><img loading='lazy' src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=!${activePackage.frontDoorChamID}&type=prod&extra=(focus=200)&Size=200`} alt={`Product - ${activePackage.frontDoorChamID}`} /></div>
                    <div className={styles.name}>{activePackage.frontDoor}</div>
                </div>
            </div>
        </div>
    ) : (
        ''
    );

    return (
        <section>
            <div className={styles.content}>
                <h1>Applied Products</h1>
                <div className={styles.appliedMenu}>
                    {exteriorProducts.length > 0 && <h3>Exterior Products</h3>}
                    <ul>
                        {exteriorProducts}
                    </ul>
                    {extScheme}
                    {kitchenProducts.length > 0 && <h3>Kitchen Products</h3>}
                    <ul>
                        {kitchenProducts}
                    </ul>
                    {bathroomProducts.length > 0 && <h3>Bathroom Products</h3>}
                    <ul>
                        {bathroomProducts}
                    </ul>
                </div>
            </div>
        </section>
    );
}